import styled from 'styled-components';
import { Paper } from '@material-ui/core';

export const MainContainer = styled.main`
  padding-left: 250px;
  width: 100%;
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 1rem;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-size: 1.75rem;
  color: #282828;
  margin: 0;
`;

export const Subtitle = styled.span`
  font-size: 0.85rem;
  color: #757575;
  margin-top: 0.25rem;
`;

export const SearchWrapper = styled.div`
  margin-bottom: 1rem;
  max-width: 320px;
`;

export const CompanyCell = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CompanyLogo = styled.img`
  height: 20px;
  width: auto;
`;

export const ClickableRow = styled.tr`
  cursor: pointer;

  &:hover {
    background-color: #fafafa;
  }
`;

export const RowTitle = styled.span`
  font-weight: 500;
  color: #282828;
`;

export const ErrorsHint = styled.span`
  color: #C62828;
  font-size: 0.8rem;
  margin-left: 0.25rem;
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
  color: ${(props) => props.statusColor || '#666'};
  background-color: ${(props) => props.statusBg || 'transparent'};
`;

export const EmptyState = styled.div`
  padding: 3rem 1rem;
  text-align: center;
  color: #888;
`;

export const SkeletonBar = styled.div`
  height: 12px;
  width: 100%;
  background-color: #eee;
`;

export const SearchIcon = styled.div`
  margin-right: 8px;
  color: #999;
`;

export const StyledTableContainer = styled(Paper)`
  overflow-x: auto;
`;
